import type { ProductConfig } from '../../default/product/product.types';
import type { DeepPartial } from '../../default/types';

export const productConfig: DeepPartial<ProductConfig> = {
  recommendations: {
    dv: {
      slots: {
        1: 'searchProductToProducts',
        4: 'searchReplace',
      },
    },
    atb: {
      slots: {
        1: 'searchBasketToProducts',
        2: null,
      },
    },
  },
  cliplister: {
    enabled: false,
  },
  flixmedia: {
    distributorId: 18441,
    enabled: true,
  },
  hasKIM: false,
};
